import { render, staticRenderFns } from "./FederationSelectField.vue?vue&type=template&id=2c442ba6&scoped=true"
import script from "./FederationSelectField.vue?vue&type=script&lang=ts"
export * from "./FederationSelectField.vue?vue&type=script&lang=ts"
import style0 from "./FederationSelectField.vue?vue&type=style&index=0&id=2c442ba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c442ba6",
  null
  
)

export default component.exports